export { default as spinner } from "./spinner.json"
